import React, { useEffect } from "react";
import profilePic from "../../../assets/user.jpg"
import './profile.scss'
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import { useAppDispatch, useAppSelector } from "../../../store/hooks/hooks";
import { getEvents } from "../../../store/StudentAction";
import EventList from "../../adminDashboard/meetings/eventsList/eventList";

const Profile = () => {
    const userDetails = useAppSelector((state: any) => state.user.user)
    const placementDetails = useAppSelector((state) => state.user.placement)
    const events =  useAppSelector((state) => state.user.events)
    const dispatch = useAppDispatch()
    const fetchEventList = async () => {
        await dispatch(getEvents("all"))
    }
    useEffect(() => {
        fetchEventList()
    },[])


    return (
        <>
            <div className="profileContainer">

                <div className="align-items-center flex flex-column profileGriditem-1">
                    <div className="pt-3 px-3 w-100">
                        <h4 className="cardTitle">Profile</h4>
                    </div>
                    <img src={profilePic} alt="profilePicture" className="profilePic"></img>
                    <p className="font-weight-700 m-0">{userDetails.first_name} {userDetails.last_name}</p>
                    <p className="body-p gray-color subTitle">{userDetails.email}</p>
                </div>
                <div>
                    <div className="align-items-center flex flex-row p-2 m-2">
                        <div className="jobIconContainer mx-2 p-2">
                            <BadgeRoundedIcon fontSize="small" />
                        </div>
                        <div>
                            <p className="font-weight-700 m-0">{placementDetails.JobRoles}</p>
                            <p className="body-p gray-color m-0 subTitle">Role</p>
                        </div>
                    </div>
                    <div className="align-items-center flex flex-row p-2 m-2">
                        <div className="jobIconContainer mx-2 p-2">
                            <BusinessRoundedIcon fontSize="small" />
                        </div>
                        <div>
                            <p className="font-weight-700 m-0">{placementDetails.CompanyName}</p>
                            <p className="body-p gray-color m-0 subTitle">Company</p>
                        </div>
                    </div>
                </div>
                {/* <Calender></Calender> */}
            </div>
            <div className="mt-3">
                {
                    events.length > 0 && <EventList events={events} ></EventList>
                }
            </div>
        </>

    )

}
export default Profile;